import { Module } from 'vuex';
import { types } from './mutation-types';
/**
 * VueX pattern
 * View -> Actions -> State -> View ...
 *
 * State -> VueComponent -> Action -> --Commit-- Mutations(change state) -> State
 *
 * Projects Vuex modules structure base on : https://vuex.vuejs.org/guide/structure.html
 */
type VirtualCardState = {
  virtualCardFile: string;
  vc_token: string;
  fileSummary: Array<any>;
  total: number;
}

function getDefaultState(): VirtualCardState {
  return {
    vc_token: '',
    virtualCardFile: '',
    fileSummary: [],
    total: 0,
  };
}

export const virtualCard: Module<VirtualCardState, any> = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    setVirtualCardFile({ commit }, virtualCardFilePath: string) {
      commit(types.SEND_VIRTUAL_CARD_FILE, virtualCardFilePath);
    },
    setVirtualCardToken({ commit }, virtualCardToken: string) {
      commit(types.SET_VIRTUAL_CARD_TOKEN, virtualCardToken);
    },
    setFileSummary({ commit }, fileSummary: Array<any>) {
      commit(types.SET_FILE_SUMMARY, fileSummary);
    },
    setTotal({ commit }, total: number) {
      commit(types.SET_TOTAL, total);
    },
    reset({ commit }) {
      commit(types.RESET);
    },
    hydrate({ commit }, state: Partial<VirtualCardState>) {
      commit(types.HYDRATE, state);
    },
  },
  mutations: {
    [types.SEND_VIRTUAL_CARD_FILE](state: VirtualCardState, payload: string) {
      state.virtualCardFile = payload;
    },
    [types.SET_VIRTUAL_CARD_TOKEN](state: VirtualCardState, payload: string) {
      state.vc_token = payload;
    },
    [types.SET_FILE_SUMMARY](state: VirtualCardState, payload: Array<any>) {
      state.fileSummary = payload;
    },
    [types.RESET](state: VirtualCardState) {
      state.vc_token = '';
      state.virtualCardFile = '';
      state.fileSummary = [];
      state.total = 0;
    },
    [types.SET_TOTAL](state: VirtualCardState, payload: number) {
      state.total = payload;
    },
    [types.HYDRATE](state: VirtualCardState, payload: Partial<VirtualCardState> = {}) {
      Object.assign(state, getDefaultState(), payload);
    },
  },
};
